module.exports = __webpack_public_path__ + "img/waringBule.0f149105.svg";